import { BoxProps, Box } from '@chakra-ui/react';
import { FC, PropsWithChildren } from 'react';

export const DatePickerHeaderActions: FC<PropsWithChildren<BoxProps>> = (
  props
) => <Box h="40px" mr="-4px" {...props} />;
